import {
  Avatar,
  Button,
  Divider,
  Popover,
  PopoverChevron,
  PopoverContent,
  PopoverTrigger,
  Typography
} from '@sollapay/ui';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {getInitials} from '@/utils/get-initials.utils';

const INLINE_VISIBLE_COUNT = 2;
const MAX_WITHOUT_POPOVER = 3;

interface BuyerNamesSummaryProps {
  buyerNames: string[];
}

export function BuyerNamesSummary({buyerNames}: BuyerNamesSummaryProps) {
  const {t, i18n} = useTranslation('trustAccounts');
  const [open, setOpen] = useState(false);

  if (buyerNames.length <= MAX_WITHOUT_POPOVER) {
    const listFormatter = new Intl.ListFormat(i18n.language, {style: 'long', type: 'conjunction'});
    return <>{listFormatter.format(buyerNames)}</>;
  }

  const overflow = buyerNames.length - INLINE_VISIBLE_COUNT;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {buyerNames.slice(0, INLINE_VISIBLE_COUNT).join(', ')}{' '}
      <PopoverTrigger
        render={
          <Button
            variant="tertiary"
            size="xs"
            className="h-auto gap-0.5 p-0 text-xs hover:bg-transparent"
            onClick={e => e.stopPropagation()}
          >
            {t('view.activity.moreBuyers', {count: overflow})}
            <PopoverChevron className="size-3 text-inherit" />
          </Button>
        }
      />
      <PopoverContent side="bottom" align="start" className="w-64 p-1.25">
        <div className="max-h-80 overflow-y-auto">
          {open &&
            buyerNames.map((name, index) => (
              <div key={name}>
                {index > 0 && <Divider className="bg-border-subtle" />}
                <div className="flex items-center gap-2 rounded p-1">
                  <Avatar initials={getInitials(name).slice(0, 1)} size="xs" seed={name} noShadow />
                  <Typography size="sm" className="whitespace-normal">
                    {name}
                  </Typography>
                </div>
              </div>
            ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
